import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import { t } from "i18next";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { useModal } from "../../../core/context/ModalContext";
import { useUser } from "../../../core/context/UserContext";
import Helper from "../../../core/Helper";
import ApiService from "../../../core/service/ApiService";
import PaymentSummary from "./PaymentSummary";

const { Text } = Typography;

export const AppointmentSummaryCard = () => {
    const { queryModel } = useDataGrid();
    const { openModal } = useModal();
    const { formatPrice } = useUser();
    const [summary, setSummary] = useState({
        appointmentSummaries: [],
        entitlementSummary: []
    });

    const openPaymentSummaryByMethod = () => {
        openModal(t('Summary'), (
            <PaymentSummary data={summary} />
        ));
    };

    const get = async () => {
        const input = {
            ...queryModel.filter,
            startDate: Helper.Date.beginOfDay(queryModel.filter.startDate),
            endDate: Helper.Date.endOfDay(queryModel.filter.endDate),
        };
        const res = await ApiService.Appointment.GetAppointmentDataGridSummary(input);
        if (res.success) {
            setSummary(res.data);
        }
    };

    useEffect(() => {
        get();
    }, [queryModel.updateKey]);

    if (!summary?.appointmentSummaries || summary.appointmentSummaries.length === 0) {
        return null;
    }

    return (
        <div style={{
            background: '#fafafa',
            border: '1px solid #e8e8e8',
            borderRadius: 6,
            padding: 12
        }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 10,
                paddingBottom: 8,
                borderBottom: '1px solid #f0f0f0'
            }}>
                <Text strong style={{ fontSize: 14 }}>{t('General Total')}</Text>
                <Text type="secondary" style={{ fontSize: 11 }}>
                    {summary.appointmentSummaries.length} kur
                </Text>
            </div>

            {summary.appointmentSummaries.map((s, i) => {
                const hasDebt = s.total > 0;
                return (
                    <div
                        key={i}
                        style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr',
                            gap: 8,
                            paddingTop: i > 0 ? 8 : 0,
                            marginTop: i > 0 ? 8 : 0,
                            borderTop: i > 0 ? '1px dashed #f0f0f0' : 'none'
                        }}
                    >
                        <div>
                            <div style={{ fontSize: 10, color: '#8c8c8c' }}>{t('Price')}</div>
                            <Text style={{ fontSize: 13 }}>
                                {formatPrice(s.totalPrice, { currency: s.currency })}
                            </Text>
                        </div>
                        <div>
                            <div style={{ fontSize: 10, color: '#8c8c8c' }}>{t('Paid')}</div>
                            <a
                                onClick={openPaymentSummaryByMethod}
                                style={{ fontSize: 13, fontWeight: 600, color: '#1890ff' }}
                            >
                                {formatPrice(s.totalPaid, { currency: s.currency })}
                            </a>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontSize: 10, color: '#8c8c8c' }}>{t('Balance')}</div>
                            <Text strong style={{
                                fontSize: 15,
                                color: hasDebt ? '#cf1322' : '#389e0d'
                            }}>
                                {formatPrice(s.total, { currency: s.currency })}
                            </Text>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
